/**
 * Created by ostapenko.r on 1/30/2015.
 */

angular.module('flipto.components.reports', []);